@import '../../responsive/responsive-mixin';

$sizes: 1024, 0;

ui-realestate-search {
  @include responsive($sizes);

  display: block;

  sd-spinner {
    display: block;
    margin: 0 auto;
    margin-top: 25px;
  }

  .realestate-filters {
    position: relative;
    padding: 30px 0;
    z-index: 2;

    .ui-image {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      z-index: -1;
    }

    ui-headline {
      margin-bottom: 20px;
    }

    .ui-paragraph {
      margin-bottom: 30px;
      font-size: 20px;
      color: $ui-blue;
    }

    .filter-wrapper {
      padding: 0 10px;
      display: block;

      .realestate-info {
        width: 66.66%;
      }
    }

    &.hasBgImage {
      .filter-wrapper {
        width: 65%;
        margin: 0 auto;

        .realestate-info {
          width: auto;
        }
      }
    }

    .slide {
      @media (min-width: 415px) {
        width: 70%;
      }

      .search-facets-panel__link {
        margin-bottom: 35px;
      }
    }

    ui-realestate-search-filters {
      .filters {
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 4%;
        row-gap: 18px;
      }

      .years {
        display: flex;
        align-items: center;
        gap: 25px;
        flex-flow: row wrap;

        &__label {
          @media (min-width: $small) {
            width: 25%;
          }
        }

        &__inputs {
          display: flex;
          align-items: center;
          gap: 25px;
          width: calc(75% - 25px);
        }

        &__error-message {
          width: 100%;
          color: $ui-red;
          font-weight: 500;
        }
      }

      ui-button {
        margin: 20px 20px 0 0;
      }

      .search-info {
        display: inline-block;
        margin-top: 0;

        ui-offcanvas-trigger,
        span {
          display: inline-block;
        }
      }
    }

    &.mobile {
      .filter-wrapper {
        width: auto;
      }

      .filters {
        grid-template-columns: 1fr;
      }

      .search-info {
        margin-top: 20px;
        display: block;

        ui-offcanvas-trigger {
          display: block;
        }
      }
    }
  }
}
